// extracted by mini-css-extract-plugin
export var left = "TwoColumnContent-module--left--b53a0";
export var right = "TwoColumnContent-module--right--051d8";
export var wrapper = "TwoColumnContent-module--wrapper--d2ac1";